import React from 'react';
import { Button, Form, Input, Segment, Tab } from 'semantic-ui-react';
import axios from 'axios';
import moment from 'moment';
import { toast, ToastContainer } from 'react-toastify';
import { DateTimePicker } from 'react-widgets';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const object = {};
const fetchGradingMethods = () => axios.get('/grading-methods');
const fetchExamTypes = () => axios.get('/graded-activity-types');


export default class NewExamByTerm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: '',
            name: '',
            academicYearId: '',
            gradingMethods: [],
            examTypes: [],
            courseStaff: [],
            groups: [],
            groupIds: null,

            gradingMethod: '',
            examType: '',
            course: '',
            staffArray: [],
            date: null,
            classroom: '',
            comment: '',

            gradingMethodErr: false,
            examTypeErr: false,
            examTermErr: false,
            staffArrayErr: false,
            dateErr: false,
            added: null,
            thirdCycle: localStorage.getItem('thirdCycle') === 'true',
            specialist: localStorage.getItem('specialist') === 'true',

            startDate: null,
            endDate: null,

            disabledButton: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.addExam = this.addExam.bind(this);
        this.fetchAll = this.fetchAll.bind(this);
        this.resetForm = this.resetForm.bind(this);
    }


    componentDidMount() {
        this.fetchAll();
    }


    fetchAll() {
        axios.all([fetchGradingMethods(), fetchExamTypes()])
            .then(axios.spread((gradingMethodRes, examTypeRes) => {
                const gradingMethods = gradingMethodRes.data.map(el => ({
                    ...el, text: el.name, value: el.id, key: el._key
                }));
                const examTypes = examTypeRes.data.map(el => ({
                    ...el, text: el.name, value: el.id, key: el.id
                }));

                this.setState({
                    examTypes,
                    gradingMethods,
                    gradingMethodId: gradingMethods.find(e => e.key === 'written exam').id,
                });
            }))
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch data...');
            });
    }


    addExam(examTypeId, gradingMethodId, date, staffArray, classroom, groupIds, comment) {
        const requiresStaff = !this.state.thirdCycle && !this.state.specialist;

        if (!examTypeId || !gradingMethodId || !date || (staffArray.length === 0 && requiresStaff)) {
            toast('Niste unijeli sva obavezna polja!');
            if (!examTypeId) { this.setState({ examTypeErr: true }); } else { this.setState({ examTypeErr: false }); }
            if (!gradingMethodId) { this.setState({ gradingMethodIdErr: true }); } else { this.setState({ gradingMethodIdErr: false }); }
            if (!date) { this.setState({ dateErr: true }); } else { this.setState({ dateErr: false }); }
            if (staffArray.length === 0 && requiresStaff) { this.setState({ staffArrayErr: true }); } else { this.setState({ staffArrayErr: false }); }
            this.setState({disabledButton: false });
        } else if (requiresStaff && !groupIds && staffArray.filter(el => this.state.courseStaff.find((e) => e.id === el).leadStaff).length !== 1) {
            this.setState({
                staffArrayErr: true,
                disabledButton: false
            });
            toast('Ispit mora imati tačno jednog profesora nosioca!');
        } else if (requiresStaff && groupIds && staffArray.filter(el => this.state.courseStaff.find((e) => e.id === el).courseRoleType.name === 'profesor').length !== 1) {
            this.setState({
                staffArrayErr: true,
                disabledButton: false
            });
            toast('Ispit sa grupom mora imati tačno jednog profesora!');
        } else {
            const {
                examTypes, gradingMethods
            } = this.state;
            this.setState({
                staffArrayErr: false,
                examTermErr: false,
                examTypeErr: false,
                dateErr: false,
                gradingMethodErr: false,
                disabledButton: false
            });
            const courseImplementationId = this.state.course;
            let examDate = moment(date).format();

            const gradedActivityRegistrationDate = { id: this.props.examTerm - 1 };

            const staff = staffArray.map(el => ({ id: el }));

            let gradedActivityTypeKey = examTypes.find(el => el.id === examTypeId)._key;

            let gradingMethodKey = gradingMethods.find(el => el.id === gradingMethodId)._key;


            let docExam = {
                gradedActivityRegistrationDate,
                courseImplementationId,
                gradedActivityTypeKey,
                gradingMethodKey,
                examDate,
                staff,
                classroom
            };

            if (comment) { docExam = { ...docExam, comment }; }


            axios.post('exams/false', { ...docExam })
                .then(res => {
                    if (groupIds) {
                        let groups = [];
                        groups.push(groupIds);
                        axios.post(`exams/add-group/${res.data.gradedActivityId}`, [...groups])
                            .then(() => {
                                toast('Uspješno ste kreirali ispit i dodali grupu na ispit.');
                                this.resetForm();
                            }).catch(err => {
                                toast('Došlo je do greške. Dodavanje grupe na ispit nije uspjelo.');
                            });
                    } else {
                        toast('Uspješno ste kreirali ispit.');
                        this.resetForm();
                    }
                })
                .catch(err => {
                    toast('Došlo je do greške. Kreiranje ispita nije izvršeno.');
                });
        }
    }


    handleChange(name, date) {
        if (moment(date).format('D.M.YYYY.') !== moment(this.state.startDate).format('D.M.YYYY.') && moment(date).format('D.M.YYYY.') !== moment(this.state.endDate).format('D.M.YYYY.')) {
            if (date < this.props.startDate || date > this.props.endDate) {
                toast('Datum ispita mora biti unutar vremenskog intervala odabranog ispitnog roka!');
                return;
            }
        }

        this.setState({
            [name]: date
        });
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });

        if (name === 'course') {
            const selectedCourse = this.props.courses.find(course => course.value === value);
            const courseBasicId = selectedCourse ? selectedCourse.courseBasicId : value;

            axios.get(`/course/implementation/staff/${value}`)
                .then(res => {
                    this.setState({
                        courseStaff: res.data.map(el => ({
                            ...el, text: el.employee.person.firstName + ' ' + el.employee.person.lastName + ' - ' + el.courseRoleType.name, value: el.id, key: el.id
                        }))
                    });
                })
                .catch(err => {
                    console.log('Failed to fetch course staff.');
                });

            axios.get('/group-types')
                .then(res => {
                    const groupType = res.data.find(e => e._key === 'exam').id;
                    let obj = {};
                    axios.post(`course/groups/${value}/${groupType}`, { ...obj })
                        .then(result => {
                            let groups = result.data.filter(e => !e.archived).map(el => ({
                                text: el.name, value: el.id, key: el.id
                            }));
                            this.setState({
                                groups,
                                haveGroup: groups.length !== 0
                            });
                        })
                        .catch(err => {
                            console.log('Failed to fetch groups');
                        });
                })
                .catch(err => {
                    console.log('Failed to fetch group types');
                });

            axios.get(`course/third-cycle-check/${courseBasicId}/`)
                .then(res => {
                    if (res.data) {
                        localStorage.setItem('thirdCycle', true);
                        this.setState({ thirdCycle: true, staffArrayErr: false });
                    } else {
                        localStorage.setItem('thirdCycle', false);
                        this.setState({ thirdCycle: false });
                    }
                }).catch(err => {
                    console.log('Failed to fetch third cycle');
                });

            axios.get(`course/specialist-study-program-check/${courseBasicId}/`)
                .then(res => {
                    if (res.data) {
                        localStorage.setItem('specialist', true);
                        this.setState({ specialist: true, staffArrayErr: false });
                    } else {
                        localStorage.setItem('specialist', false);
                        this.setState({ specialist: false });
                    }
                }).catch(err => {
                    console.log('Failed to fetch specialist study');
                });
        }
    }

    resetForm() {
        this.setState({
            date: null,
            examType: null,
            groupIds: null,
            staffArray: [],
            classroom: '',
            comment: '',
            course: null,
            thirdCycle: false,
            specialist: false,
            disabledButton: false
        });
    }

    render() {
        return (
            <div>
                <Form noValidate>
                    <Form.Group widths="equal" >
                        <Form.Field required error={this.state.examTermErr} disabled={!this.props.showForm}>
                            <label>Predmet</label>
                            <Form.Dropdown
                                clearable
                                selection
                                placeholder="Odaberite predmet"
                                value={this.state.course}
                                onChange={this.handleInputChange}
                                name="course"
                                options={this.props.courses}
                                search
                                fluid
                            />
                        </Form.Field>
                        <Form.Field required error={this.state.dateErr} disabled={!this.props.showForm}>
                            <label>Datum i vrijeme ispita</label>
                            <DateTimePicker
                                defaultValue={new Date()}
                                format="D. M. YYYY. - HH:mm"
                                timeFormat="HH:mm"
                                onChange={this.handleChange.bind(null, 'date')}
                                value={this.state.date}
                                placeholder="Unesite datum u formatu D. M. GGGG."
                            />
                        </Form.Field>

                    </Form.Group>
                    <Form.Group widths="equal">
                        <Form.Field required error={this.state.examTypeErr} disabled={!this.props.showForm}>
                            <label>Tip ispita</label>
                            <Form.Dropdown
                                clearable
                                selection
                                placeholder="Odaberite tip ispita"
                                value={this.state.examType}
                                onChange={this.handleInputChange}
                                name="examType"
                                options={this.state.examTypes.filter(el => el.id === 2 || el.id === 3)}
                                search
                                fluid
                            />
                        </Form.Field>
                        <Form.Field required error={this.state.gradingMethodIdErr} disabled={!this.props.showForm}>
                            <label>Način ispitivanja</label>
                            <Form.Dropdown
                                clearable
                                selection
                                placeholder="Odaberite način ispitivanja"
                                value={this.state.gradingMethodId}
                                onChange={this.handleInputChange}
                                name="gradingMethodId"
                                options={this.state.gradingMethods}
                                search
                                fluid
                            />
                        </Form.Field>
                    </Form.Group>

                    <Form.Group widths="equal">
                        <Form.Field disabled={!this.props.showForm}>
                            <label>Ispitna grupa</label>
                            <Form.Dropdown
                                clearable
                                selection
                                placeholder="Odaberite grupu"
                                value={this.state.groupIds}
                                onChange={this.handleInputChange}
                                name="groupIds"
                                options={this.state.groups}
                                search
                                fluid
                            />

                        </Form.Field>

                        <Form.Field disabled={!this.props.showForm} required={!this.state.thirdCycle && !this.state.specialist} error={this.state.staffArrayErr}>
                            <label>Osoblje zaduženo za ispit</label>
                            <Form.Dropdown
                                clearable
                                selection
                                multiple
                                placeholder="Odaberite osoblje"
                                value={this.state.staffArray}
                                onChange={this.handleInputChange}
                                name="staffArray"
                                options={!this.state.haveGroup ? this.state.courseStaff.filter(el => (el.archived !== true && (el.leadStaff === true || el.courseRoleType.name === 'asistent'))) : this.state.courseStaff.filter(el => el.archived !== true)}
                                search
                                fluid
                            />
                        </Form.Field>
                    </Form.Group>
                    <Form.Group widths="equal">
                        <Form.Field
                            disabled={!this.props.showForm}
                            label="Prostorija"
                            control={Input}
                            name="classroom"
                            value={this.state.classroom}
                            onChange={this.handleInputChange}
                            placeholder="Unesite prostoriju"
                        />
                        <Form.Field disabled={!this.props.examTerm}>
                            <label> Napomena</label>
                            <Form.TextArea
                                placeholder="Unesite napomenu"
                                rows={2}
                                name="comment"
                                value={this.state.comment}
                                onChange={this.handleInputChange}
                            />
                        </Form.Field>
                    </Form.Group>


                    <Button
                        floated="right"
                        basic="true"
                        color="blue"
                        disabled={!this.props.showForm}
                        onClick={() => {
                            this.resetForm();
                        }}
                    >
                        Odustani
                    </Button>

                    <Button
                        disabled={!this.props.showForm || this.state.disabledButton}
                        floated="right"
                        color="blue"
                        onClick={
                            () => {
                                this.setState({ disabledButton: true }, () => {
                                    this.addExam(
                                        this.state.examType,
                                        this.state.gradingMethodId,
                                        this.state.date,
                                        this.state.staffArray,
                                        this.state.classroom,
                                        this.state.groupIds,
                                        this.state.comment
                                    );
                                });
                            }
                        }
                    >
                        Kreiraj ispit
                    </Button>

                </Form>

                <ToastContainer hideProgressBar />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/Exams/NewExamByTerm.js